import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const statusConfig = {
  compliant: { color: '#22c55e', bg: 'rgba(34,197,94,0.1)', border: 'rgba(34,197,94,0.3)', label: 'FULLY COMPLIANT', icon: 'CheckCircle' },
  pending: { color: '#f59e0b', bg: 'rgba(245,158,11,0.1)', border: 'rgba(245,158,11,0.3)', label: 'PENDING REVIEW', icon: 'Clock' },
  violation: { color: '#ef4444', bg: 'rgba(239,68,68,0.1)', border: 'rgba(239,68,68,0.3)', label: 'VIOLATION FOUND', icon: 'AlertTriangle' }
};

const mockResults = {
  'RAJUK-2024-001': {
    status: 'compliant',
    projectName: 'Bashundhara Residential Complex',
    developer: 'Bashundhara Group',
    rajukApproval: 'RAJUK-APP-2022-4521',
    deedNumber: 'DEED-DHA-2024-78934',
    buildingPermit: 'BP-DHA-2024-00123',
    landUseClass: 'Residential (RA)',
    city: 'Dhaka',
    area: 'Bashundhara R/A',
    completionCert: 'CC-2024-4521',
    handoverDate: 'Q2 2025',
    constructionProgress: 82,
    violations: [],
    lastUpdated: '2025-02-20'
  },
  'RAJUK-2024-002': {
    status: 'pending',
    projectName: 'Agrabad Commercial Tower',
    developer: 'Chittagong Developers Ltd.',
    rajukApproval: 'CDA-APP-2023-3312',
    deedNumber: 'DEED-CTG-2024-56721',
    buildingPermit: 'BP-CTG-2024-00456',
    landUseClass: 'Commercial (CA)',
    city: 'Chittagong',
    area: 'Agrabad',
    completionCert: 'Pending',
    handoverDate: 'Q4 2025',
    constructionProgress: 48,
    violations: ['Minor documentation delay in CDA approval'],
    lastUpdated: '2025-02-18'
  },
  'RAJUK-2024-003': {
    status: 'violation',
    projectName: 'Mirpur Unauthorized Structure',
    developer: 'Unknown Developer',
    rajukApproval: 'Not Issued',
    deedNumber: 'DEED-DHA-2024-34512',
    buildingPermit: 'Not Issued',
    landUseClass: 'Disputed',
    city: 'Dhaka',
    area: 'Mirpur',
    completionCert: 'Not Issued',
    handoverDate: 'Halted',
    constructionProgress: 15,
    violations: ['No RAJUK building permit', 'Unauthorized construction', 'Land use violation — residential zone breach'],
    lastUpdated: '2025-02-15'
  }
};

const RAJUKComplianceChecker = () => {
  const [query, setQuery] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCheck = () => {
    if (!query?.trim()) { setError('Please enter a property registration or RAJUK approval number'); return; }
    setError('');
    setLoading(true);
    setResult(null);
    setTimeout(() => {
      const found = mockResults?.[query?.trim()?.toUpperCase()];
      if (found) { setResult(found); }
      else {
        setResult({
          status: 'compliant',
          projectName: 'Sample Property',
          developer: 'Sample Developer Ltd.',
          rajukApproval: 'RAJUK-APP-2022-' + Math.floor(Math.random() * 9999),
          deedNumber: 'DEED-DHA-2024-' + Math.floor(Math.random() * 99999),
          buildingPermit: 'BP-DHA-2024-' + Math.floor(Math.random() * 99999),
          landUseClass: 'Residential (RA)',
          city: 'Dhaka',
          area: 'Gulshan',
          completionCert: 'CC-2024-' + Math.floor(Math.random() * 9999),
          handoverDate: 'Q3 2025',
          constructionProgress: 70,
          violations: [],
          lastUpdated: '2025-02-26'
        });
      }
      setLoading(false);
    }, 1500);
  };

  const cfg = result ? statusConfig?.[result?.status] : null;

  return (
    <div className="rounded-2xl p-6 md:p-8" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,180,80,0.25)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)' }}>
          <Icon name="Search" size={20} color="#00B450" />
        </div>
        <div>
          <h2 className="text-lg md:text-xl font-bold" style={{ color: '#E8F4FF' }}>Instant RAJUK Compliance Checker</h2>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>Enter property registration number, RAJUK approval ID, or deed number</p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <input
          type="text"
          value={query}
          onChange={e => setQuery(e?.target?.value)}
          onKeyDown={e => e?.key === 'Enter' && handleCheck()}
          placeholder="e.g. RAJUK-2024-001, RAJUK-2024-002, RAJUK-2024-003"
          className="flex-1 px-4 py-3 rounded-xl text-sm outline-none"
          style={{ background: 'rgba(0,180,80,0.05)', border: '1px solid rgba(0,180,80,0.2)', color: '#E8F4FF' }}
        />
        <button
          onClick={handleCheck}
          disabled={loading}
          className="px-6 py-3 rounded-xl font-semibold text-sm transition-all duration-200"
          style={{ background: loading ? 'rgba(0,180,80,0.3)' : '#00B450', color: '#FFFFFF' }}
        >
          {loading ? 'Verifying...' : 'Verify Now'}
        </button>
      </div>
      {error && <p className="text-sm mb-4" style={{ color: '#ef4444' }}>{error}</p>}
      <div className="flex flex-wrap gap-2 mb-6">
        {Object.keys(mockResults)?.map(key => (
          <button key={key} onClick={() => setQuery(key)} className="px-3 py-1 rounded-lg text-xs transition-all" style={{ background: 'rgba(0,180,80,0.08)', border: '1px solid rgba(0,180,80,0.2)', color: '#00B450' }}>
            Try: {key}
          </button>
        ))}
      </div>
      {result && cfg && (
        <div className="rounded-xl p-5 mt-2" style={{ background: cfg?.bg, border: `1px solid ${cfg?.border}` }}>
          <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
            <div className="flex items-center gap-2">
              <Icon name={cfg?.icon} size={20} color={cfg?.color} />
              <span className="font-bold text-sm" style={{ color: cfg?.color }}>{cfg?.label}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(0,180,80,0.1)', color: '#00B450', border: '1px solid rgba(0,180,80,0.3)' }}>
                🏙️ {result?.city} — {result?.area}
              </span>
              <span className="text-xs" style={{ color: '#6B9EC4' }}>Updated: {result?.lastUpdated}</span>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
            {[
              { label: 'Project Name', value: result?.projectName },
              { label: 'Developer', value: result?.developer },
              { label: 'RAJUK Approval No.', value: result?.rajukApproval },
              { label: 'Deed Number', value: result?.deedNumber },
              { label: 'Building Permit', value: result?.buildingPermit },
              { label: 'Land Use Classification', value: result?.landUseClass },
              { label: 'Completion Certificate', value: result?.completionCert },
              { label: 'Handover Date', value: result?.handoverDate }
            ]?.map((item, i) => (
              <div key={i} className="p-3 rounded-lg" style={{ background: 'rgba(10,22,40,0.6)' }}>
                <div className="text-xs mb-1" style={{ color: '#6B9EC4' }}>{item?.label}</div>
                <div className="text-sm font-medium" style={{ color: '#E8F4FF' }}>{item?.value}</div>
              </div>
            ))}
          </div>
          <div className="mb-3">
            <div className="flex justify-between text-xs mb-1" style={{ color: '#6B9EC4' }}>
              <span>Construction Progress</span>
              <span style={{ color: cfg?.color }}>{result?.constructionProgress}%</span>
            </div>
            <div className="h-2 rounded-full" style={{ background: 'rgba(255,255,255,0.1)' }}>
              <div className="h-2 rounded-full transition-all" style={{ width: `${result?.constructionProgress}%`, background: cfg?.color }} />
            </div>
          </div>
          {result?.violations?.length > 0 && (
            <div className="mt-3">
              <div className="text-xs font-semibold mb-2" style={{ color: '#ef4444' }}>⚠ Violations Found:</div>
              {result?.violations?.map((v, i) => (
                <div key={i} className="text-xs py-1 px-2 rounded mb-1" style={{ background: 'rgba(239,68,68,0.1)', color: '#fca5a5' }}>• {v}</div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RAJUKComplianceChecker;
